import React from "react";
import * as uuid from "uuid";
import { TripsReportsRow } from "../../../api/models/TripsReportsRow";
import {
    LoadingTableElement,
    NullTableElement,
} from "../../../components/table/nullTable";
import {
    SortableTable,
    newDisplayCond,
} from "../../../components/table/sortableTable";
import { convertNeedGuidanceToCheckMark } from "../../../services/common/convert";
import { convertBoardingType } from "../../../utils/formatting";
import { Row, headCells } from "./columns_trips";

export const convertTripReportsToDataTableFormat = (
    tripReportsList?: TripsReportsRow[] | null
): Row[] => {
    if (!tripReportsList) {
        return [];
    }

    const _data = tripReportsList.map((rec: TripsReportsRow) => {
        const ng = convertNeedGuidanceToCheckMark(rec.needGuidance);
        return {
            need_guidance: convertNeedGuidanceToCheckMark(rec.needGuidance),
            unladen_start_time: rec.unladenStartTs,
            unladen_start_city: rec.unladenStartCity,
            deliver_start_time: rec.boardingTs,
            deliver_start_city: rec.boardingCity,
            unladen_time: rec.unladenSec,
            wheel_time: rec.handleTime,
            pause_car_request_sec: rec.pauseCarRequestSec,
            boarding_type: convertBoardingType(rec.boardingType),
            navi_off_time: rec.naviOffSec,
            deviation_count: rec.deviationCount,
            go_cancel_count: rec.goCancelCount,
            deboarding_time: rec.deliverTs,
            deboarding_city: rec.deliverCity,
            is_hermes_off: rec.isHermesOff,
            navi_off_sec: rec.naviOffSec,
            is_deviation: rec.isDeviation,
            is_go_cancel: rec.isGoCancel,
            trip: rec,
            trip_session_id: rec.tripSessionId,
            login_session_id: rec.loginSessionId,
            row_id: uuid.v4(),
        } as Row;
    });
    return _data;
};

interface TableProps {
    trips?: TripsReportsRow[] | null;
}

export const TripsTable: React.FC<TableProps> = (props: TableProps) => {
    const _data = convertTripReportsToDataTableFormat(props.trips);

    if (!props.trips) {
        return <LoadingTableElement />;
    }

    if (props.trips.length == 0) {
        return <NullTableElement />;
    }

    return (
        <SortableTable
            tableHeaders={headCells}
            tableData={_data}
            tableProps={props}
            displayCond={newDisplayCond("unladen_start_time", "asc", 0, 20)}
            rowIdField={"row_id"}
            onRowClickMethod={() => {}}
            slimRows={true}
        />
    );
};
